import { InputHTMLAttributes } from 'react';
import ReactInputMask from 'react-input-mask';
import { BarcodeIcon } from 'static/icons';
import * as S from './styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {}

export function Ean({ name, value, onBlur, onChange }: Props) {
  return (
    <S.Main>
      <S.Label>Digite ou scaneie o código no campo abaixo</S.Label>

      <S.InputWrapper>
        <S.Icon>
          <BarcodeIcon />
        </S.Icon>

        <S.Division />

        <ReactInputMask
          name={name}
          id={name}
          type="text"
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          mask="9999999999999"
          maskChar={null}
        />
      </S.InputWrapper>
    </S.Main>
  );
}
